/**
 * Distance lisible : "950 m", "2,4 km", "17,8 km".
 */
export function formatDistance(meters: number): string {
  if (!Number.isFinite(meters) || meters < 0) return '-';

  if (meters < 1000) {
    // Arrondi a la dizaine de metres : la precision au metre n'apporte rien.
    const rounded = Math.round(meters / 10) * 10;
    if (rounded < 1000) return `${rounded} m`;
  }

  const km = meters / 1000;
  return `${km.toLocaleString('fr-FR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })} km`;
}

/** Note Google : "4,6". */
export function formatRating(rating: number | null): string {
  if (rating === null || !Number.isFinite(rating)) return '-';
  return rating.toLocaleString('fr-FR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
}

/** Date ISO (AAAA-MM-JJ ou datetime SQLite) affichee en francais. */
export function formatDate(value: string | null): string {
  if (value === null || value.trim().length === 0) return '-';
  const date = new Date(value.includes('T') ? value : value.replace(' ', 'T') + 'Z');
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('fr-FR');
}

/** Lien tel: utilisable depuis un mobile comme depuis un softphone. */
export function telHref(phone: string): string {
  return `tel:${phone.replace(/[^+\d]/g, '')}`;
}

/**
 * Recherche Google sur une entreprise.
 *
 * L'adresse accompagne le nom quand elle est connue : « Le Fournil » seul
 * ramene des boulangeries de toute la France, alors que le meme nom suivi de
 * sa rue tombe sur la bonne fiche.
 */
export function googleSearchHref(name: string, address?: string | null): string {
  const query = [name, address].filter((part) => (part ?? '').trim().length > 0).join(' ');
  return `https://www.google.com/search?q=${encodeURIComponent(query)}`;
}

/** Affiche "exemple.fr" plutot que "https://www.exemple.fr/contact?utm=..." */
export function shortenUrl(url: string): string {
  try {
    const parsed = new URL(url);
    return parsed.hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return count > 1 ? plural : singular;
}
